import { ID } from 'types';
import { VALID_LINE_ITEM_COLUMN_IDS } from '@components/bid_request/details/constants';

export const isCustomColumn = (header: ID): boolean => {
  const validColumnIds = new Set<string>(VALID_LINE_ITEM_COLUMN_IDS);

  return !validColumnIds.has(String(header));
};
